import "./index.scss"

import React from "react"
import {Helmet} from "react-helmet"

import {Navigate, useLocation} from "react-router-dom"

import NSLogoImage from "../../assets/images/logo_newsoft.svg"
import {ProfileRoute} from "../../routes"
import SmallButton from "../../toolkits/SmallButton/SmallButton"
import {useCustomHistory} from "../../hooks/useCustomHistory"


const Error = () => {
    const location = useLocation()
    const history = useCustomHistory()

    return (location.state ?
        <div className="error">
            <Helmet>
                <title> {location.state.errorInfo} </title>
            </Helmet>
            <img src={NSLogoImage} alt="Newsoft logo"/>
            <div className="error-info">
                <p className="t-h1">{location.state.errorInfo}</p>
            </div>
            <div className="error-return-button">
                <SmallButton
                    type="submit"
                    onClick={() => history.push("/")}
                >Go To Profile</SmallButton>
            </div>
        </div> : <Navigate to={{pathname: ProfileRoute.path}} replace />
    )
}

export default Error
